
import React from "react";

const AccountDelete=()=> {
 


 
    return (
      <div className="page-container">
        <section className="section">
          <h1>How to delete your FlowRead account</h1>
          <p>
            If you have registered a FlowRead account and would like to delete it, please contact us via email:
          </p>
          <p>
            📧 <strong>Email:</strong>{" "}
            <a href="mailto:sunev@sunev.xyz">sunev@sunev.xyz</a>
          </p>
          <p>
            <strong>Subject:</strong> Account Deletion Request
          </p>
          <p>
            In your message, please include the following information:
          </p>
          <ul>
            <li>Your registered email address</li>
            <li>Your username (if applicable)</li>
          </ul>
          <p>
            This will help us verify your identity and ensure your account is securely removed.
          </p>
          <p>
            Once we verify your request, your account and all associated data will be permanently deleted within 7 days.
          </p>
          <p>
            If your use of the FlowRead app does not involve account registration, no personal account data is stored.
          </p>
        </section>
      </div>
    );
  };
  

  export default AccountDelete
  